export const submitStatusList = [
  {
    valueId:'N',
    valueName:'待上传'
  },
  {
    valueId:'Y',
    valueName:'已上传'
  }
]